import { FC } from "react";
import { Route } from "nextjs-routes";
import LibraryItemDetailPageHeaderLeft from "./LibraryItemDetailPageHeaderLeft";
import LibraryItemDetailPageHeaderRight from "./LibraryItemDetailPageHeaderRight";
import LibraryItemDetailPage from "@src/deprecatedDesignSystem/components/LibraryItemDetailPage";
import { LibraryItemDetailPage_LibraryItemFragment } from "./LibraryItemDetailPageContainer.generated";
import LibraryItemDetailPageHeaderNav from "./LibraryItemDetailPageHeaderNav";
import { useLibraryItemQueryParams } from "@builder/contexts/LibraryItemQueryParamsContext";
import useUser from "@src/hooks/useUser";
import BuilderActionSyncingErrorBanner from "./shared/BuilderActionSyncingErrorBanner";

type Props = {
  libraryItem: LibraryItemDetailPage_LibraryItemFragment;
  hasEditTitlePermission?: boolean;
  onTitleClick?: () => void;
  titleComponent: React.ReactNode;
  backRoute?: Route;
  translationModeEnabled?: boolean;
  setTranslationModeEnabled?: (enabled: boolean) => void;
  onShareClick?: () => void;
  shareDisabled?: boolean;
  hasPublishPermission?: boolean;
  hasCommentPermission?: boolean;
  onPublishClick?: () => void;
  onPreviewClick?: () => void;
  publishDisabled?: boolean;
  publishLoading?: boolean;
  publishButtonText?: string;
  onAssignClick?: () => void;
  assignDisabled?: boolean;
  extraButtons?: React.ReactNode;
  overflowItems?: React.ReactNode;
  hidePublishButton?: boolean;
};

const LibraryItemDetailPageHeader: FC<Props> = ({
  onTitleClick,
  titleComponent,
  backRoute,
  translationModeEnabled,
  setTranslationModeEnabled,
  onShareClick,
  shareDisabled,
  hasPublishPermission,
  hasCommentPermission,
  onPublishClick,
  publishDisabled,
  publishLoading,
  publishButtonText = "Publish",
  onAssignClick,
  assignDisabled,
  extraButtons,
  overflowItems,
  libraryItem,
  hidePublishButton = false,
}) => {
  const { selectedMainTab } = useLibraryItemQueryParams();
  const { user } = useUser();
  return (
    <>
      <BuilderActionSyncingErrorBanner />
      <LibraryItemDetailPage.Header>
        <LibraryItemDetailPageHeaderLeft
          titleComponent={titleComponent}
          onTitleClick={onTitleClick}
          backRoute={backRoute}
        />
        {libraryItem.org && libraryItem.org.id === user?.org?.id && (
          <>
            <LibraryItemDetailPageHeaderNav />
            <LibraryItemDetailPageHeaderRight
              selectedMainTab={selectedMainTab}
              translationModeEnabled={translationModeEnabled}
              setTranslationModeEnabled={setTranslationModeEnabled}
              onShareClick={onShareClick}
              shareDisabled={shareDisabled}
              hasPublishPermission={hasPublishPermission}
              hasCommentPermission={hasCommentPermission}
              onPublishClick={onPublishClick}
              publishDisabled={publishDisabled}
              publishLoading={publishLoading}
              publishButtonText={publishButtonText}
              onAssignClick={onAssignClick}
              assignDisabled={assignDisabled}
              extraButtons={extraButtons}
              overflowItems={overflowItems}
              hidePublishButton={hidePublishButton}
            />
          </>
        )}
      </LibraryItemDetailPage.Header>
    </>
  );
};

export default LibraryItemDetailPageHeader;
